/**
 * A zero-dependency RFC-4180 subset for the admin bulk-import dialogs: quoted
 * fields, `""` escapes, commas and newlines inside quotes, CRLF or LF line
 * endings, blank lines skipped. Not a general CSV parser — good enough for
 * what a spreadsheet actually exports.
 */
export function parseCsv(input) {
    // Excel saves a UTF-8 BOM on "CSV UTF-8" exports; left in, it would glue
    // itself onto the first header's name.
    const text = input.charCodeAt(0) === 0xfeff ? input.slice(1) : input;
    const allRows = [];
    const rowStartLines = [];
    let field = '';
    let row = [];
    let inQuotes = false;
    let line = 1;
    let rowStartedAtLine = 1;
    let rowHasContent = false;
    const endField = () => {
        row.push(field);
        field = '';
    };
    const endRow = () => {
        endField();
        // A blank line — nothing typed, no commas — is not a row.
        if (row.length > 1 || row[0] !== '') {
            allRows.push(row);
            rowStartLines.push(rowStartedAtLine);
        }
        row = [];
        rowHasContent = false;
    };
    for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (!rowHasContent && field === '' && row.length === 0)
            rowStartedAtLine = line;
        if (inQuotes) {
            if (ch === '"') {
                if (text[i + 1] === '"') {
                    field += '"';
                    i++;
                }
                else {
                    inQuotes = false;
                }
            }
            else {
                if (ch === '\n')
                    line++;
                field += ch;
            }
            continue;
        }
        if (ch === '"' && field === '') {
            inQuotes = true;
            rowHasContent = true;
            continue;
        }
        if (ch === ',') {
            endField();
            rowHasContent = true;
            continue;
        }
        if (ch === '\r')
            continue;
        if (ch === '\n') {
            line++;
            endRow();
            continue;
        }
        field += ch;
        rowHasContent = true;
    }
    // A file with no trailing newline still has one more field/row to close.
    if (field !== '' || row.length > 0)
        endRow();
    const [headerRow, ...dataRows] = allRows;
    return { headers: headerRow ?? [], rows: dataRows, lines: rowStartLines.slice(1) };
}
/**
 * The inverse of parseCsv, for the admin's template-download and export
 * downloads: quotes a field only when it needs it, `""`-escapes embedded
 * quotes, LF line endings, no BOM (parseCsv strips one on read, so writing
 * one would just be dead weight). `null`/`undefined` cells serialize as the
 * empty field.
 */
export function serializeCsv(headers, rows) {
    const formatRow = (cells) => cells
        .map((cell) => {
        const text = cell === null || cell === undefined ? '' : String(cell);
        return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
    })
        .join(',');
    return [headers, ...rows].map(formatRow).join('\n');
}
//# sourceMappingURL=csv.js.map